<template>
  <div class="index">
    <div class="fixed-top">
        <!-- <div class="header">
            <div class="header-left">
                <img src="@/assets/logo.png" >
                <div class="header-nav">
                    <a href="http://www.52muyou.com" target="_blank">关于我们</a>
                </div>
            </div>
            <div class="header-right">
                <p>收藏</p>
            </div>
        </div> -->
        <div class="navs">
            <div class="navs-left">
                <img src="@/assets/zyj-icon.png" alt="">
            </div>
            <div class="navs-center">
                <a href="http://zyj.52muyou.com/home.html">官网首页</a>
                <a href="http://zyj.52muyou.com/news.html">最新公告</a>
                <a href="/" class="bg-light" :class="$route.path === '/'?'active' : ''" @click.prevent="goIndexPage"></a>
                <p class="zyj-logo">
                    <a href="http://zyj.52muyou.com/home.html">
                        <img src="@/assets/zyj-logo.png" >
                    </a>
                </p>
                <a href="http://zyj.52muyou.com/shows.html">角色图鉴</a>
                <a href="http://zyj.52muyou.com/jmbz.html">精美壁纸</a>
                <div v-if="!noLogin">
                    <!-- <router-link to="/user"><el-avatar :size="50" :src="circleUrl"></el-avatar></router-link> -->
                    <el-dropdown>
                        <router-link :class="$route.path === '/user'?'active' : ''" to="/user">个人中心</router-link>
                        <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item><router-link to="/user">个人中心</router-link></el-dropdown-item>
                        <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div v-if="noLogin" class="auth-box">
                    <router-link :class="$route.path === '/login'? 'active': ''" :to="{ path:'/login', query: {...$route.query}}">登录</router-link>
                    <router-link :class="$route.path === '/register'? 'active': ''" :to="{ path:'/register', query: {...$route.query}}">注册</router-link>
                </div>
            </div>
            <div class="focus">
                <div class="wx">
                    <p class="wx-hover">
                        <span></span>
                        <img class="ewm-code" src="http://mcdn.52muyou.com/static/zyj/wap/images/weixin.png">
                    </p>
                </div>
                <a href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDgyNTMxOF80ODIwMzFfODAwODI1MzE4XzJf" target="_blank" class="qq"></a>
                <a href="" target="_blank" class="wb"></a>
                <a href="https://tieba.baidu.com/f?kw=%D7%F7%D1%FD%BC%C6&fr=ala0&tpl=5" target="_blank" class="tb">
                </a>
            </div>
        </div>
    </div>
      <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1"><el-link href="">首页</el-link></el-menu-item>
        <el-menu-item index="2" style="float: right" v-if="noLogin"><router-link to="register">注册</router-link></el-menu-item>
        <el-menu-item index="3" style="float: right" v-if="noLogin"><router-link to="login">登录</router-link></el-menu-item>
        <el-menu-item index="3" style="float: right" v-if="!noLogin">
          <router-link to="/user"><el-avatar :size="50" :src="circleUrl"></el-avatar></router-link>

          <el-dropdown>
              <span class="el-dropdown-link">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><router-link to="/user">个人中心</router-link></el-dropdown-item>
              <el-dropdown-item><router-link to="/user/prop">已购皮肤</router-link></el-dropdown-item>
              <el-dropdown-item><router-link to="/user/order">订单列表</router-link></el-dropdown-item>
              <el-dropdown-item><router-link to="/user/role">角色列表</router-link></el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
      </el-menu> -->
      <div class="side-box">
          <div class="side-main">
              <div class="side-l1 side-line"><span><img src="@/assets/nft/side4-icon.png" alt=""></span><span>藏品交流群</span></div>
              <div class="side-l2 side-line">241639146</div>
          </div>
      </div>
      <div class="body-main">
        <router-view @Login="login" @Logout="logout"/>
      </div>

      <div class="footc footer">
          <div class="footc-cont clearfix" style="padding-top: 0px;">
              <a href="/">
                  <img alt="" src="@/assets/logo.png" class="fl" title="作妖计">
              </a>
              <div class="fl footer-text">
                  <p>
                      抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
                  </p>
                  <p>
                      北京牧游科技有限公司版权所有　京ICP备16033161号-1 京公网安备 11010802021424号
                  </p>
                  <p>
                      地址：北京市海淀区上地东路1号盈创动力园区A座北厅702B 电话：010-58851918
                  </p>
                  <p><a style="color:#757575" target="_blank" href="http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/gameNetTag/4028c08b54a4776a0154b8cd7e443c94">文网游备字〔2016〕Ｍ-RPG
                          1387 号</a></p>
                  <!-- <p>北京牧游科技</p> -->
              </div>
              <div>
                  <a target="_blank" href="http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/gameNetTag/4028c08b54a4776a0154b8cd7e443c94">
                      <img title="作妖计" alt="作妖计" src="@/assets/promptly.png" width="50px">
                  </a>
              </div>
          </div>
      </div>

      <div class="wap-header">
          <div class="mu-header mu-bg">
              <div class="mu-icon">
                  <img alt="作妖记logo" class="mu-logo js-hook js-hook-logo"
                    src="@/assets/zyj-icon.png">
              </div>
              <div class="mu-nav-content">
                  <div class="mu-title">作妖计</div>
                  <div class="mu-nav-list">
                      <a class="nav" href="http://zyj.52muyou.com/wap/">首页</a>
                      <router-link class="nav bg-light" :class="$route.path === '/'? 'active': ''" :to="{ path:'/'}"></router-link>
                      <router-link v-if="!noLogin" class="nav" :class="$route.path === '/user'? 'active': ''" :to="{ path:'/user'}">个人中心</router-link>
                      <router-link v-if="noLogin" class="nav" :class="$route.path === '/login'? 'active': ''" :to="{ path:'/login', query: {...$route.query}}">登录</router-link>
                      <router-link v-if="noLogin" class="nav" :class="$route.path === '/register'? 'active': ''" :to="{ path:'/register', query: {...$route.query}}">注册</router-link>
                      <a v-if="!noLogin" class="nav" @click.prevent="logout" >退出登录</a>
                  </div>
              </div>
              <div class="mu-download">
                  <a class="mu-link"
                    href="https://itunes.apple.com/cn/app/zuo-yao-jihd-wu-li-jue-xing/id1087708023?mt=8">下载</a>
              </div>
          </div>
      </div>

  </div>
</template>

<script>
import {getToken} from "../utils/auth";

export default {
  name: "Layout",
  data() {
    return {
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      activeIndex: '1',
      noLogin: true
    };
  },
  created() {
    if (getToken()) {
      this.noLogin = false
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key
      // console.log(key, keyPath);
    },
    login() {
      this.noLogin = false
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.noLogin = true
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    goIndexPage(){
        this.$router.push('/');
    }
  }
}
</script>

<style>
.index{
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

html,
body {
    position: relative;
    height: 100%;
    min-width: 1250px;
}

body {
    background: #e0efe9;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: #000;
    margin: 0;
    padding: 0;
}

input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {  
    -webkit-text-fill-color: #ededed !important;  
    -webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;  
    background-color:transparent;  
    background-image: none;  
    transition: background-color 50000s ease-in-out 0s;  
}  
input {  
    background-color:transparent;  
}  
</style>

<style lang="less">
.fixed-top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
}

.header {
    height: 44px;
    line-height: 44px;
    background: #13161b;
    padding: 0 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    color: #fff;
    &-left {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        img {
            width: 77px;
            height: 29px;
            margin-right: 37px;
        }
        a {
            color: #fff;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            margin-right: 41px;
            cursor: pointer;
            &:active {
                color: #d24d2e;
            }
        }
    }
    &-right {
        p {
            cursor: pointer;
            background: url('~@/assets/start.png') no-repeat left center;
            background-size: 12px 12px;
            padding-left: 15px;
            font-size: 14px;
            height: 30px;
            line-height: 30px;
            color: #d6d7db;
        }
    }
}

.navs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(0, 0, 0, .5);
    height: 85px;
    padding: 0 70px;
    box-sizing: border-box;
    .navs-left {
        width: 144px;
        img {
            display: inline-block;
            width: 58px;
            height: 58px;
            float: left;
            margin-top: 5.5px;
        }
    }
    &-center {
        width: 1000px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0 40px 0 0;
        position: relative;
        a {
            font-size: 16px;
            color: #fff;
            padding-left: 28px;
            display: inline-block;
            
            &:active {
                color: #f6e30b;
            }
            &.active {
                color: #f6e30b;
                background: url('~@/assets/icon.png') no-repeat left center;
                background-size: 20px 20px;
            }
            &.bg-light{
                background-image: url('~@/assets/nft/nav-light-1.png');
                background-repeat: no-repeat;
                background-position: center;
                padding: 0 28px;
                background-size: 100% auto;
                color: #161615;
                margin-right: -28px;
                display: inline-block;
                width: 64px;
                height: 40px;

                &.active {
                    color: #9e5223;
                    background-image: url('~@/assets/nft/nav-light-2.png');
                }
            }
        }
        .auth-box{
            display: flex;
            justify-content: space-around;
            .active{
                // color: #f6e30b;
            }
        }
        
        p {
            width: 156px;
            height: 91px;
            box-sizing: content-box;
            padding-top: 0px;
            position: absolute;
            top: 30px;
            left: 50%;
            transform: translateX(-50%);
            a {
                padding-left: 0px;
            }
            img {
                width: 100%;
            }
        }
    }
    .focus {
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;
        &>p,
        &>div,
        &>a {
            width: 30px;
            height: 30px;
            margin: 0 3px;
            display: inline-block;
        }
        .wx {
            background: url('~@/assets/wx.png') no-repeat center;
            background-size: 100% 100%;
            position: relative;
            &:hover {
                background: url('~@/assets/wx-hover.png') no-repeat center;
                background-size: 100% 100%;
            }
        }
        .wx-hover {
            width: 100px;
            height: 100px;
            position: absolute;
            bottom: -110px;
            left: -33px;
            display: none;
            span {
                width: 0;
                height: 0;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 8px solid #fff;
                position: absolute;
                top: -4px;
                left: 40px;
            }
            img {
                width: 100px;
                height: 100px;
            }
        }
        .qq {
            background: url('~@/assets/qq.png') no-repeat center;
            background-size: 100% 100%;
            &:hover {
                background: url('~@/assets/qq-hover.png') no-repeat center;
                background-size: 100% 100%;
            }
        }
        .wb {
            background: url('~@/assets/wb.png') no-repeat center;
            background-size: 100% 100%;
            &:hover {
                background: url('~@/assets/wb-hover.png') no-repeat center;
                background-size: 100% 100%;
            }
        }
        .tb {
            background: url('~@/assets/tb.png') no-repeat center;
            background-size: 100% 100%;
            &:hover {
                background: url('~@/assets/tb-hover.png') no-repeat center;
                background-size: 100% 100%;
            }
        }
    }
}

.footer {
    width: 100%;
    height: 138px;
    background: #2b292a;
    // position: absolute;
    // bottom: 0;
    // left: 0;
    // z-index: 100;
    .footc-cont {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 138px;
        width: 1000px;
        margin: 0 auto;
        &>a {
            width: 151px;
        }
        &>.footer-text {
            text-align: left;
            font-size: 12px;
            color: #a9a9a9;
            margin: 0 20px;
            // line-height: 24px;
        }
    }
}

.body-main{
    // background: rgb(224,239,233);
    min-height: calc(100vh - 138px);
}

.comment-all {
    background: #514855 url('~@/assets/nft/bg-06.jpg') no-repeat top;
    background-size: 100% 100vh;
    background-attachment: fixed;
    min-height: calc(100vh - 138px);
    width: 100%;
    overflow: hidden;
}

.side-box{
    position: fixed;
    top: 62%;
    right: 6px;
    width: 161px;
    height: 222px;
    background: url('~@/assets/nft/side-bg.png') no-repeat top;
    background-size: cover;
    z-index: 100;
    .side-main{
        width: 110px;
        height: 60px;
        // background: #ffffff;
        position: absolute;
        color: #e4dac6;
        left: 50%;
        top: 70%;
        transform: translate(-50%, -50%);
    }
    .side-line{
        line-height: 26px;
        &.side-l1 {
            margin-top: 5px;
            text-align: center;
            font-size: 14px;
        }
        &.side-l2{
            text-align: center;
            font-size: 18px;
        }
    }
}
</style>



<style lang="less">
.wap-header{
    display: none;
}
/* 移动端的CSS样式代码 */
@media screen and (max-width: 750px) {
    html,
    body {
        position: relative;
        height: 100%;
        min-width: 350px;
        font-size: 14px;
    }
    .fixed-top{
        display: none;
    }
    .comment-all {
        background: #514855 url('~@/assets/nft-wap/bg-06.png') no-repeat center;
        background-size: 100% 100%;
        background-attachment: fixed;
        min-height: 100vh;
        width: 100%;
        overflow: hidden;
    }
    .side-box{
        display: none;
    }
    .footer {
        display: none;
    }
    .wap-header{
        display: block;
		position: fixed;
        width: 100%;
		// height: 50px;
		left: 0;
		top: 0;
		max-width: 100%;
		right: 0;
		margin: 0 auto;
		z-index: 9;
        .mu-header{
            display: flex;
          &.mu-bg {
            background: url('~@/assets/nft-wap/info-bg.png') no-repeat bottom;
            background-size: 100% 500%;
          }
          .mu-icon {
            width: 76px;
            height: 76px;
            margin: 6px 2px 6px 2px;
            // display: inline-block;
            img{
                width: 100%;
                height: 100%;
            }
          }
          .mu-nav-content{
            flex: 1;
            position: relative;
          }
          .mu-title{
            color: #fcbf56;
            font-size: 18px;
            margin: 4px 10px;
            font-weight: bold;
          }
          .mu-nav-list{
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            margin-top: 16px;
            margin-right: 8px;
            .nav{
              padding: 4px 10px;
              background: url('~@/assets/nft-wap/nav-bg.png') no-repeat center;
              background-size: 100% 100%;
              color: #161615;
              display: block;
              &.active{
                color: #9e5223;
                font-weight: bold;
              }
              &.bg-light{
                background-image: url('~@/assets/nft/nav-light-1.png'),url('~@/assets/nft-wap/nav-bg.png');
                background-repeat: no-repeat, no-repeat;
                background-position: center, center;
                background-size: 90% auto, 100% 100%;
                // background-image: url('~@/assets/nft/nav-light-1.png');
                // background-repeat: no-repeat;
                // background-position: center;
                // padding: 0 28px;
                // background-size: 100% auto;
                color: #161615;
                // margin-right: -28px;
                display: inline-block;
                width: 64px;
                height: 20px;
                &.active {
                    color: #9e5223;
                    background-image: url('~@/assets/nft/nav-light-2.png'),url('~@/assets/nft-wap/nav-bg.png');
                    background-size: 90% auto, 100% 100%;
                }
              }
            }
          }
          .mu-download{
            width: 60px;
            height: 30px;
            background: url('~@/assets/nft-wap/download-bg.png') no-repeat center;
            background-size: 100% auto;
            margin-right: 5px;
            position: absolute;
            right: 4px;
            top: 10px;
            .mu-link{
              display: block;
              text-align: center;
              font-size: 16px;
              color: #9e5223;
              font-weight: bold;
              line-height: 32px;
              margin: 0 auto 0 auto;
            }
          }

          
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/layout/index.vue